/*
 *  -----------------------------------------------------------------------
 *    <copyright file="heading-actions/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import './styles.scss';
import { HeadingActionsProps } from './heading-actions.interface';
import cn from 'clsx';

const HeadingActions = ({ items }: HeadingActionsProps) => (
    <div className="heading-actions">
        {items.map(({ element, action, disabled, 'data-testid': dataTestId }) => (
            <button
                type="button"
                className={cn('heading-actions__item', { disabled })}
                disabled={disabled}
                onClick={action ? () => action() : undefined}
                data-testid={dataTestId}
            >
                {element}
            </button>
        ))}
    </div>
);

export default HeadingActions;
